import React, {
  FC,
  MutableRefObject,
  ReactNode,
  RefObject,
  useCallback,
  useRef,
} from "react";
import { GetRef, Select } from "antd";
import useFocus from "../../documentSet/hooks/useFocus";
import { Option } from "../dataRefining/interfaces/filteringData";
import DropdownActions from "./dropdownActions/DropdownActions";

type SelectRef = GetRef<typeof Select>;

// See TableHeaderFilter.tsx for why these filter props are still `any`.
/* eslint-disable @typescript-eslint/no-explicit-any */
type Props = {
  label: ReactNode;
  isOpen: boolean;
  value: any;
  prop: any;
  updateFilter: (prop: any, value: any) => void;
  renderRef: RefObject<HTMLDivElement | null>;
  options: Array<Option>;
};
/* eslint-enable @typescript-eslint/no-explicit-any */

const FilterableItem: FC<Props> = ({
  label,
  isOpen,
  value,
  prop,
  updateFilter,
  renderRef,
  options,
}) => {
  const ref: MutableRefObject<null | SelectRef> = useRef(null);
  const { open, setOpen } = useFocus(ref, isOpen);

  const handleChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value: any) => {
      updateFilter(prop, value);
    },
    [updateFilter, prop],
  );

  return (
    <div className="filter-popover__item">
      {label}
      <Select
        ref={ref}
        mode={"multiple"}
        open={open}
        onDropdownVisibleChange={(open) => setOpen(open)}
        value={value}
        options={options}
        placeholder={"Search"}
        onChange={handleChange}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        // The container div this ref points at is always mounted by the time
        // the popup asks for it.
        getPopupContainer={() => renderRef.current!}
        allowClear
        dropdownRender={(menu) => (
          <DropdownActions handleOkClick={() => setOpen(false)}>
            {menu}
          </DropdownActions>
        )}
      />
    </div>
  );
};

export default FilterableItem;
